/* @generated from adl module myc.scoring.db */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_db from './../../common/db';
import * as common_strings from './../../common/strings';

/**
 * Details for a user
 */
export interface AppUser {
  fullname: common_strings.StringNE;
  email: common_strings.StringNE;
  isAdmin: boolean;
  hashedPassword: common_strings.StringNE;
}

export function makeAppUser(
  input: {
    fullname: common_strings.StringNE,
    email: common_strings.StringNE,
    isAdmin: boolean,
    hashedPassword?: common_strings.StringNE,
  }
): AppUser {
  return {
    fullname: input.fullname,
    email: input.email,
    isAdmin: input.isAdmin,
    hashedPassword: input.hashedPassword === undefined ? "" : input.hashedPassword,
  };
}

const AppUser_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["email"]],"label":["fullname"]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details for a user\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"isAdmin","default":{"kind":"nothing"},"name":"isAdmin","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"hashedPassword","default":{"kind":"just","value":""},"name":"hashedPassword","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"AppUser","version":{"kind":"nothing"}}};

export const snAppUser: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"AppUser"};

export function texprAppUser(): ADL.ATypeExpr<AppUser> {
  return {value : {typeRef : {kind: "reference", value : snAppUser}, parameters : []}};
}

export type AppUserId = common_db.DbKey<AppUser>;

const AppUserId_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"AppUser"}},"parameters":[]}]}}},"name":"AppUserId","version":{"kind":"nothing"}}};

export const snAppUserId: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"AppUserId"};

export function texprAppUserId(): ADL.ATypeExpr<AppUserId> {
  return {value : {typeRef : {kind: "reference", value : snAppUserId}, parameters : []}};
}

/**
 * Each season is a collection of series
 */
export interface Season {
  name: common_strings.StringNE;
}

export function makeSeason(
  input: {
    name: common_strings.StringNE,
  }
): Season {
  return {
    name: input.name,
  };
}

const Season_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"label":["name"],"uniquenessConstraints":[["name"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Each season is a collection of series\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"Season","version":{"kind":"nothing"}}};

export const snSeason: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"Season"};

export function texprSeason(): ADL.ATypeExpr<Season> {
  return {value : {typeRef : {kind: "reference", value : snSeason}, parameters : []}};
}

export type SeasonId = common_db.DbKey<Season>;

const SeasonId_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Season"}},"parameters":[]}]}}},"name":"SeasonId","version":{"kind":"nothing"}}};

export const snSeasonId: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"SeasonId"};

export function texprSeasonId(): ADL.ATypeExpr<SeasonId> {
  return {value : {typeRef : {kind: "reference", value : snSeasonId}, parameters : []}};
}

/**
 * Each series is a collection of races
 */
export interface Series {
  seasonId: common_db.DbKey<Season>;
  name: common_strings.StringNE;
  abbreviation: common_strings.StringNE;
  isHandicap: boolean;
  handicapSystem: (HandicapSystem|null);
  numDrops: number;
}

export function makeSeries(
  input: {
    seasonId: common_db.DbKey<Season>,
    name: common_strings.StringNE,
    abbreviation: common_strings.StringNE,
    isHandicap: boolean,
    handicapSystem: (HandicapSystem|null),
    numDrops: number,
  }
): Series {
  return {
    seasonId: input.seasonId,
    name: input.name,
    abbreviation: input.abbreviation,
    isHandicap: input.isHandicap,
    handicapSystem: input.handicapSystem,
    numDrops: input.numDrops,
  };
}

const Series_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"label":["abbreviation"],"uniquenessConstraints":[["seasonId","name"],["seasonId","abbreviation"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Each series is a collection of races\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"seasonId","default":{"kind":"nothing"},"name":"seasonId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Season"}},"parameters":[]}]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"abbreviation","default":{"kind":"nothing"},"name":"abbreviation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"isHandicap","default":{"kind":"nothing"},"name":"isHandicap","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"handicapSystem","default":{"kind":"nothing"},"name":"handicapSystem","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"HandicapSystem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"numDrops","default":{"kind":"nothing"},"name":"numDrops","typeExpr":{"typeRef":{"kind":"primitive","value":"Word8"},"parameters":[]}}]}},"name":"Series","version":{"kind":"nothing"}}};

export const snSeries: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"Series"};

export function texprSeries(): ADL.ATypeExpr<Series> {
  return {value : {typeRef : {kind: "reference", value : snSeries}, parameters : []}};
}

export enum HandicapSystem {
  v1,
  v2,
}

const HandicapSystem_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"v1","default":{"kind":"nothing"},"name":"v1","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"v2","default":{"kind":"nothing"},"name":"v2","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"HandicapSystem","version":{"kind":"nothing"}}};

export const snHandicapSystem: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"HandicapSystem"};

export function texprHandicapSystem(): ADL.ATypeExpr<HandicapSystem> {
  return {value : {typeRef : {kind: "reference", value : snHandicapSystem}, parameters : []}};
}

export type SeriesId = common_db.DbKey<Series>;

const SeriesId_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Series"}},"parameters":[]}]}}},"name":"SeriesId","version":{"kind":"nothing"}}};

export const snSeriesId: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"SeriesId"};

export function texprSeriesId(): ADL.ATypeExpr<SeriesId> {
  return {value : {typeRef : {kind: "reference", value : snSeriesId}, parameters : []}};
}

/**
 * A Race 
 */
export interface Race {
  scheduledDate: common.LocalDate;
  raceNumber: number;
  dutyOfficer: string;
}

export function makeRace(
  input: {
    scheduledDate: common.LocalDate,
    raceNumber: number,
    dutyOfficer?: string,
  }
): Race {
  return {
    scheduledDate: input.scheduledDate,
    raceNumber: input.raceNumber,
    dutyOfficer: input.dutyOfficer === undefined ? "" : input.dutyOfficer,
  };
}

const Race_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"label":["scheduledDate","raceNumber"]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A Race \n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"scheduledDate","default":{"kind":"nothing"},"name":"scheduledDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"raceNumber","default":{"kind":"nothing"},"name":"raceNumber","typeExpr":{"typeRef":{"kind":"primitive","value":"Word8"},"parameters":[]}},{"annotations":[],"serializedName":"dutyOfficer","default":{"kind":"just","value":""},"name":"dutyOfficer","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"Race","version":{"kind":"nothing"}}};

export const snRace: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"Race"};

export function texprRace(): ADL.ATypeExpr<Race> {
  return {value : {typeRef : {kind: "reference", value : snRace}, parameters : []}};
}

/**
 * A Calendar entry, shown in the schedule
 * but otherwise has no effect
 */
export interface CalendarEntry {
  seasonId: common_db.DbKey<Season>;
  date: common.LocalDate;
  description: common_strings.StringNE;
}

export function makeCalendarEntry(
  input: {
    seasonId: common_db.DbKey<Season>,
    date: common.LocalDate,
    description: common_strings.StringNE,
  }
): CalendarEntry {
  return {
    seasonId: input.seasonId,
    date: input.date,
    description: input.description,
  };
}

const CalendarEntry_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"label":["description"]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A Calendar entry, shown in the schedule\nbut otherwise has no effect\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"seasonId","default":{"kind":"nothing"},"name":"seasonId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Season"}},"parameters":[]}]}},{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"CalendarEntry","version":{"kind":"nothing"}}};

export const snCalendarEntry: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"CalendarEntry"};

export function texprCalendarEntry(): ADL.ATypeExpr<CalendarEntry> {
  return {value : {typeRef : {kind: "reference", value : snCalendarEntry}, parameters : []}};
}

export type RaceId = common_db.DbKey<Race>;

const RaceId_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Race"}},"parameters":[]}]}}},"name":"RaceId","version":{"kind":"nothing"}}};

export const snRaceId: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"RaceId"};

export function texprRaceId(): ADL.ATypeExpr<RaceId> {
  return {value : {typeRef : {kind: "reference", value : snRaceId}, parameters : []}};
}

export interface RaceStart {
  raceId: common_db.DbKey<Race>;
  date: common.LocalDate;
  abandoned: boolean;
  startTime: common.LocalTime;
  conditions: common_strings.StringML;
  notes: common_strings.StringML;
}

export function makeRaceStart(
  input: {
    raceId: common_db.DbKey<Race>,
    date: common.LocalDate,
    abandoned: boolean,
    startTime: common.LocalTime,
    conditions: common_strings.StringML,
    notes: common_strings.StringML,
  }
): RaceStart {
  return {
    raceId: input.raceId,
    date: input.date,
    abandoned: input.abandoned,
    startTime: input.startTime,
    conditions: input.conditions,
    notes: input.notes,
  };
}

const RaceStart_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["raceId"]]}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"raceId","default":{"kind":"nothing"},"name":"raceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Race"}},"parameters":[]}]}},{"annotations":[],"serializedName":"date","default":{"kind":"nothing"},"name":"date","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"abandoned","default":{"kind":"nothing"},"name":"abandoned","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"startTime","default":{"kind":"nothing"},"name":"startTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}},{"annotations":[],"serializedName":"conditions","default":{"kind":"nothing"},"name":"conditions","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringML"}},"parameters":[]}}]}},"name":"RaceStart","version":{"kind":"nothing"}}};

export const snRaceStart: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"RaceStart"};

export function texprRaceStart(): ADL.ATypeExpr<RaceStart> {
  return {value : {typeRef : {kind: "reference", value : snRaceStart}, parameters : []}};
}

/**
 * A race in a series
 */
export interface Event {
  abbreviation: common_strings.StringNE;
  seriesId: common_db.DbKey<Series>;
  raceId: common_db.DbKey<Race>;
  raceType: RaceType;
}

export function makeEvent(
  input: {
    abbreviation: common_strings.StringNE,
    seriesId: common_db.DbKey<Series>,
    raceId: common_db.DbKey<Race>,
    raceType: RaceType,
  }
): Event {
  return {
    abbreviation: input.abbreviation,
    seriesId: input.seriesId,
    raceId: input.raceId,
    raceType: input.raceType,
  };
}

const Event_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"label":["abbreviation"],"uniquenessConstraints":[["seriesId","raceId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A race in a series\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"abbreviation","default":{"kind":"nothing"},"name":"abbreviation","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"seriesId","default":{"kind":"nothing"},"name":"seriesId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Series"}},"parameters":[]}]}},{"annotations":[],"serializedName":"raceId","default":{"kind":"nothing"},"name":"raceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Race"}},"parameters":[]}]}},{"annotations":[],"serializedName":"raceType","default":{"kind":"nothing"},"name":"raceType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"RaceType"}},"parameters":[]}}]}},"name":"Event","version":{"kind":"nothing"}}};

export const snEvent: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"Event"};

export function texprEvent(): ADL.ATypeExpr<Event> {
  return {value : {typeRef : {kind: "reference", value : snEvent}, parameters : []}};
}

export enum RaceType {
  scratch,
  pursuit,
}

const RaceType_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"scratch","default":{"kind":"nothing"},"name":"scratch","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"pursuit","default":{"kind":"nothing"},"name":"pursuit","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"RaceType","version":{"kind":"nothing"}}};

export const snRaceType: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"RaceType"};

export function texprRaceType(): ADL.ATypeExpr<RaceType> {
  return {value : {typeRef : {kind: "reference", value : snRaceType}, parameters : []}};
}

export type EventId = common_db.DbKey<Event>;

const EventId_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Event"}},"parameters":[]}]}}},"name":"EventId","version":{"kind":"nothing"}}};

export const snEventId: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"EventId"};

export function texprEventId(): ADL.ATypeExpr<EventId> {
  return {value : {typeRef : {kind: "reference", value : snEventId}, parameters : []}};
}

/**
 * Personal and boat details for an entrant
 */
export interface Entrant {
  entrantName: common_strings.StringNE;
  boatName: common_strings.StringNE;
  sailNumber: common_strings.StringNE;
}

export function makeEntrant(
  input: {
    entrantName: common_strings.StringNE,
    boatName: common_strings.StringNE,
    sailNumber: common_strings.StringNE,
  }
): Entrant {
  return {
    entrantName: input.entrantName,
    boatName: input.boatName,
    sailNumber: input.sailNumber,
  };
}

const Entrant_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"label":["entrantName"],"uniquenessConstraints":[["entrantName"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Personal and boat details for an entrant\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"entrantName","default":{"kind":"nothing"},"name":"entrantName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"boatName","default":{"kind":"nothing"},"name":"boatName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"sailNumber","default":{"kind":"nothing"},"name":"sailNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"Entrant","version":{"kind":"nothing"}}};

export const snEntrant: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"Entrant"};

export function texprEntrant(): ADL.ATypeExpr<Entrant> {
  return {value : {typeRef : {kind: "reference", value : snEntrant}, parameters : []}};
}

export type EntrantId = common_db.DbKey<Entrant>;

const EntrantId_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Entrant"}},"parameters":[]}]}}},"name":"EntrantId","version":{"kind":"nothing"}}};

export const snEntrantId: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"EntrantId"};

export function texprEntrantId(): ADL.ATypeExpr<EntrantId> {
  return {value : {typeRef : {kind: "reference", value : snEntrantId}, parameters : []}};
}

/**
 * Which competitors are entered in which seasons
 */
export interface SeasonEntry {
  seasonId: common_db.DbKey<Season>;
  entrantId: common_db.DbKey<Entrant>;
  yardstick: number;
  initialHandicap: number;
}

export function makeSeasonEntry(
  input: {
    seasonId: common_db.DbKey<Season>,
    entrantId: common_db.DbKey<Entrant>,
    yardstick: number,
    initialHandicap: number,
  }
): SeasonEntry {
  return {
    seasonId: input.seasonId,
    entrantId: input.entrantId,
    yardstick: input.yardstick,
    initialHandicap: input.initialHandicap,
  };
}

const SeasonEntry_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["seasonId","entrantId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Which competitors are entered in which seasons\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"seasonId","default":{"kind":"nothing"},"name":"seasonId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Season"}},"parameters":[]}]}},{"annotations":[],"serializedName":"entrantId","default":{"kind":"nothing"},"name":"entrantId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Entrant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"yardstick","default":{"kind":"nothing"},"name":"yardstick","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"initialHandicap","default":{"kind":"nothing"},"name":"initialHandicap","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"SeasonEntry","version":{"kind":"nothing"}}};

export const snSeasonEntry: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"SeasonEntry"};

export function texprSeasonEntry(): ADL.ATypeExpr<SeasonEntry> {
  return {value : {typeRef : {kind: "reference", value : snSeasonEntry}, parameters : []}};
}

/**
 * An entrants results in a single race
 */
export interface RaceResult {
  raceId: common_db.DbKey<Race>;
  entrantId: common_db.DbKey<Entrant>;
  result: Result<common.LocalTime>;
}

export function makeRaceResult(
  input: {
    raceId: common_db.DbKey<Race>,
    entrantId: common_db.DbKey<Entrant>,
    result: Result<common.LocalTime>,
  }
): RaceResult {
  return {
    raceId: input.raceId,
    entrantId: input.entrantId,
    result: input.result,
  };
}

const RaceResult_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["raceId","entrantId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An entrants results in a single race\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"raceId","default":{"kind":"nothing"},"name":"raceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Race"}},"parameters":[]}]}},{"annotations":[],"serializedName":"entrantId","default":{"kind":"nothing"},"name":"entrantId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Entrant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"result","default":{"kind":"nothing"},"name":"result","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Result"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}]}}]}},"name":"RaceResult","version":{"kind":"nothing"}}};

export const snRaceResult: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"RaceResult"};

export function texprRaceResult(): ADL.ATypeExpr<RaceResult> {
  return {value : {typeRef : {kind: "reference", value : snRaceResult}, parameters : []}};
}

/**
 * An entrants result in a single event
 */
export interface EventResult {
  entrantId: common_db.DbKey<Entrant>;
  eventId: common_db.DbKey<Event>;
  entrantName: common_strings.StringNE;
  boatName: common_strings.StringNE;
  sailNumber: common_strings.StringNE;
  yardstick: number;
  handicap: number;
  handicapSecs: number;
  finishTime: Result<common.LocalTime>;
  elapsedTime: Result<Duration>;
  elapsedTimeYardstick: Result<Duration>;
  elapsedTimeHandicap: Result<Duration>;
  score: number;
  handicapChange: number;
  handicapNew: number;
}

export function makeEventResult(
  input: {
    entrantId: common_db.DbKey<Entrant>,
    eventId: common_db.DbKey<Event>,
    entrantName: common_strings.StringNE,
    boatName: common_strings.StringNE,
    sailNumber: common_strings.StringNE,
    yardstick: number,
    handicap: number,
    handicapSecs: number,
    finishTime: Result<common.LocalTime>,
    elapsedTime: Result<Duration>,
    elapsedTimeYardstick: Result<Duration>,
    elapsedTimeHandicap: Result<Duration>,
    score: number,
    handicapChange: number,
    handicapNew: number,
  }
): EventResult {
  return {
    entrantId: input.entrantId,
    eventId: input.eventId,
    entrantName: input.entrantName,
    boatName: input.boatName,
    sailNumber: input.sailNumber,
    yardstick: input.yardstick,
    handicap: input.handicap,
    handicapSecs: input.handicapSecs,
    finishTime: input.finishTime,
    elapsedTime: input.elapsedTime,
    elapsedTimeYardstick: input.elapsedTimeYardstick,
    elapsedTimeHandicap: input.elapsedTimeHandicap,
    score: input.score,
    handicapChange: input.handicapChange,
    handicapNew: input.handicapNew,
  };
}

const EventResult_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["eventId","entrantId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An entrants result in a single event\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"entrantId","default":{"kind":"nothing"},"name":"entrantId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Entrant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"eventId","default":{"kind":"nothing"},"name":"eventId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Event"}},"parameters":[]}]}},{"annotations":[],"serializedName":"entrantName","default":{"kind":"nothing"},"name":"entrantName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"boatName","default":{"kind":"nothing"},"name":"boatName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"sailNumber","default":{"kind":"nothing"},"name":"sailNumber","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"yardstick","default":{"kind":"nothing"},"name":"yardstick","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"handicap","default":{"kind":"nothing"},"name":"handicap","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"handicapSecs","default":{"kind":"nothing"},"name":"handicapSecs","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"finishTime","default":{"kind":"nothing"},"name":"finishTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Result"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}]}},{"annotations":[],"serializedName":"elapsedTime","default":{"kind":"nothing"},"name":"elapsedTime","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Result"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Duration"}},"parameters":[]}]}},{"annotations":[],"serializedName":"elapsedTimeYardstick","default":{"kind":"nothing"},"name":"elapsedTimeYardstick","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Result"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Duration"}},"parameters":[]}]}},{"annotations":[],"serializedName":"elapsedTimeHandicap","default":{"kind":"nothing"},"name":"elapsedTimeHandicap","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Result"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Duration"}},"parameters":[]}]}},{"annotations":[],"serializedName":"score","default":{"kind":"nothing"},"name":"score","typeExpr":{"typeRef":{"kind":"primitive","value":"Word16"},"parameters":[]}},{"annotations":[],"serializedName":"handicapChange","default":{"kind":"nothing"},"name":"handicapChange","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[],"serializedName":"handicapNew","default":{"kind":"nothing"},"name":"handicapNew","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"EventResult","version":{"kind":"nothing"}}};

export const snEventResult: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"EventResult"};

export function texprEventResult(): ADL.ATypeExpr<EventResult> {
  return {value : {typeRef : {kind: "reference", value : snEventResult}, parameters : []}};
}

/**
 * Overide a handicap before a specifed race
 */
export interface HandicapOverride {
  raceId: common_db.DbKey<Race>;
  entrantId: common_db.DbKey<Entrant>;
  handicapNew: number;
}

export function makeHandicapOverride(
  input: {
    raceId: common_db.DbKey<Race>,
    entrantId: common_db.DbKey<Entrant>,
    handicapNew: number,
  }
): HandicapOverride {
  return {
    raceId: input.raceId,
    entrantId: input.entrantId,
    handicapNew: input.handicapNew,
  };
}

const HandicapOverride_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["raceId","entrantId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Overide a handicap before a specifed race\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"raceId","default":{"kind":"nothing"},"name":"raceId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Race"}},"parameters":[]}]}},{"annotations":[],"serializedName":"entrantId","default":{"kind":"nothing"},"name":"entrantId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"myc.scoring.db","name":"Entrant"}},"parameters":[]}]}},{"annotations":[],"serializedName":"handicapNew","default":{"kind":"nothing"},"name":"handicapNew","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}]}},"name":"HandicapOverride","version":{"kind":"nothing"}}};

export const snHandicapOverride: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"HandicapOverride"};

export function texprHandicapOverride(): ADL.ATypeExpr<HandicapOverride> {
  return {value : {typeRef : {kind: "reference", value : snHandicapOverride}, parameters : []}};
}

export interface Result_Finished<T> {
  kind: 'finished';
  value: T;
}
export interface Result_Dnc<_T> {
  kind: 'dnc';
}
export interface Result_Dns<_T> {
  kind: 'dns';
}
export interface Result_Dnf<_T> {
  kind: 'dnf';
}
export interface Result_Dsq<_T> {
  kind: 'dsq';
}
export interface Result_Avg<_T> {
  kind: 'avg';
}

export type Result<T> = Result_Finished<T> | Result_Dnc<T> | Result_Dns<T> | Result_Dnf<T> | Result_Dsq<T> | Result_Avg<T>;

export interface ResultOpts<T> {
  finished: T;
  dnc: null;
  dns: null;
  dnf: null;
  dsq: null;
  avg: null;
}

export function makeResult<T, K extends keyof ResultOpts<T>>(kind: K, value: ResultOpts<T>[K]) { return {kind, value}; }

const Result_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":["T"],"fields":[{"annotations":[],"serializedName":"finished","default":{"kind":"nothing"},"name":"finished","typeExpr":{"typeRef":{"kind":"typeParam","value":"T"},"parameters":[]}},{"annotations":[],"serializedName":"dnc","default":{"kind":"nothing"},"name":"dnc","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"dns","default":{"kind":"nothing"},"name":"dns","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"dnf","default":{"kind":"nothing"},"name":"dnf","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"dsq","default":{"kind":"nothing"},"name":"dsq","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}},{"annotations":[],"serializedName":"avg","default":{"kind":"nothing"},"name":"avg","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"Result","version":{"kind":"nothing"}}};

export const snResult: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"Result"};

export function texprResult<T>(texprT : ADL.ATypeExpr<T>): ADL.ATypeExpr<Result<T>> {
  return {value : {typeRef : {kind: "reference", value : {moduleName : "myc.scoring.db",name : "Result"}}, parameters : [texprT.value]}};
}

/**
 * Time duration in seconds
 */
export type Duration = number;

const Duration_AST : ADL.ScopedDecl =
  {"moduleName":"myc.scoring.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Time duration in seconds\n"}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}},"name":"Duration","version":{"kind":"nothing"}}};

export const snDuration: ADL.ScopedName = {moduleName:"myc.scoring.db", name:"Duration"};

export function texprDuration(): ADL.ATypeExpr<Duration> {
  return {value : {typeRef : {kind: "reference", value : snDuration}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "myc.scoring.db.AppUser" : AppUser_AST,
  "myc.scoring.db.AppUserId" : AppUserId_AST,
  "myc.scoring.db.Season" : Season_AST,
  "myc.scoring.db.SeasonId" : SeasonId_AST,
  "myc.scoring.db.Series" : Series_AST,
  "myc.scoring.db.HandicapSystem" : HandicapSystem_AST,
  "myc.scoring.db.SeriesId" : SeriesId_AST,
  "myc.scoring.db.Race" : Race_AST,
  "myc.scoring.db.CalendarEntry" : CalendarEntry_AST,
  "myc.scoring.db.RaceId" : RaceId_AST,
  "myc.scoring.db.RaceStart" : RaceStart_AST,
  "myc.scoring.db.Event" : Event_AST,
  "myc.scoring.db.RaceType" : RaceType_AST,
  "myc.scoring.db.EventId" : EventId_AST,
  "myc.scoring.db.Entrant" : Entrant_AST,
  "myc.scoring.db.EntrantId" : EntrantId_AST,
  "myc.scoring.db.SeasonEntry" : SeasonEntry_AST,
  "myc.scoring.db.RaceResult" : RaceResult_AST,
  "myc.scoring.db.EventResult" : EventResult_AST,
  "myc.scoring.db.HandicapOverride" : HandicapOverride_AST,
  "myc.scoring.db.Result" : Result_AST,
  "myc.scoring.db.Duration" : Duration_AST
};
